import firebase from 'firebase/app';
import 'firebase/auth';
import router from '@/router';

import { Notification } from '@/libs/EventBus';

export default class FireBaseUtils {
  static safeGetUser(): firebase.User {
    const user = firebase.auth().currentUser;

    if (!user) {
      router.push('/');
      Notification.$emit('notify', {
        type: 'error',
        title: '請重新登入',
      });
      throw new Error('請重新登入');
    }

    return user;
  }
}
